import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button, InformationModal } from "@impero-com/ui";

interface RevokeOAuthConnectionModalProps {
    applicationName: string;
    loading: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export function RevokeOAuthConnectionModal({
    applicationName,
    loading,
    onClose,
    onConfirm,
}: RevokeOAuthConnectionModalProps) {
    const { t } = useTranslation();
    return (
        <InformationModal
            open
            onClose={onClose}
            type="error"
            title={t("OAuthConnections_RevokeDialog_Title")}
            footer={
                <>
                    <Button onClick={onClose}>{t("Cancel")}</Button>
                    <Button
                        variant="destructive"
                        loading={loading}
                        onClick={onConfirm}
                    >
                        {t("OAuthConnections_RevokeDialog_Confirm")}
                    </Button>
                </>
            }
        >
            <p>
                {t("OAuthConnections_RevokeDialog_Text", {
                    application: applicationName,
                })}
            </p>
        </InformationModal>
    );
}
